import { h } from 'preact'
import { IdeaStatus } from '../../ideation-status/Types'

interface Props {
  ideationStatuses: Array<IdeaStatus>,
  onCallback: (status: string | null) => void,
  selected: null | string
}

const IdeaStatusFilter = ({ ideationStatuses, selected, onCallback }: Props) => {
  return (
    <div className='box__content box__pad ideation-filters'>
      <h3 className='widget-title'>Filter by idea status</h3>
      <ul className='ideation-filters__idea-status'>
        <li className={selected === null ? 'selected' : ''} onClick={() => onCallback(null)}>
          <div className='vertical-line' />
          <span>All statuses</span>
        </li>
        {
          ideationStatuses.map(({ name }) => (
            <li className={selected === name ? 'selected' : ''} onClick={() => onCallback(name)}>
              <div className='vertical-line' />
              <span>{ name }</span>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default IdeaStatusFilter
